import { Date } from "core-js";

export default {
  SET_CAMPUS_LIST(state, item) {
    state.campuses = item;
  }, 
  SET_CAMPUS_RENT_AREAS(state, item) {
    state.rentcarAreas = item;
  }, 
};
